import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import i18n from '/src/locals/i18n';

// Nucleo Icons
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'flag-icons/css/flag-icons.min.css'

// Bootstrap JS
import "bootstrap/dist/js/bootstrap.bundle.min.js"

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fas, far, fab)

// PrimeVue
import PrimeVue from 'primevue/config';

// MATERIAL KIT
import materialKit from "./material-kit";

// 🧠 Head Management
import { createHead } from '@vueuse/head';

const app = createApp(App);
const head = createHead();

// 👉 Control de cookies: cargar GA solo si acepta "all"
const isLocalhost = window.location.hostname === 'localhost';

if (!isLocalhost) {
  const gaScript = document.createElement('script');
  gaScript.async = false;
  gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-H389FYRHS7';
  document.head.appendChild(gaScript);

  window.dataLayer = window.dataLayer || [];
  function gtag(){ window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', 'G-H389FYRHS7');

  // Track con Vue Router
  if (router) {
    router.afterEach((to) => {
      gtag('config', 'G-H389FYRHS7', { page_path: to.fullPath });
    });
  }
}

// QuillEditor
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

app.component('font-awesome-icon', FontAwesomeIcon);
app.use(createPinia());
app.use(router);
app.use(materialKit);
app.use(i18n);
app.use(PrimeVue);
app.use(head);
app.component('QuillEditor', QuillEditor);
app.mount("#app");
